import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 29 29",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.5 7.75V12.25M23.5 12.25V16.75M23.5 12.25H28M23.5 12.25H19M15.625 6.0625C15.625 7.40516 15.0916 8.69282 14.1422 9.64223C13.1928 10.5916 11.9052 11.125 10.5625 11.125C9.21984 11.125 7.93217 10.5916 6.98277 9.64223C6.03337 8.69282 5.5 7.40516 5.5 6.0625C5.5 4.71984 6.03337 3.43217 6.98277 2.48277C7.93217 1.53337 9.21984 1 10.5625 1C11.9052 1 13.1928 1.53337 14.1422 2.48277C15.0916 3.43217 15.625 4.71984 15.625 6.0625ZM1 25.3525V25.1875C1 22.6514 2.00747 20.2191 3.80079 18.4258C5.59411 16.6325 8.02637 15.625 10.5625 15.625C13.0986 15.625 15.5309 16.6325 17.3242 18.4258C19.1175 20.2191 20.125 22.6514 20.125 25.1875V25.351C17.2382 27.0896 13.9309 28.0057 10.561 28C7.0645 28 3.793 27.0325 1 25.351V25.3525Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }